import React from 'react';
import { useAuth } from 'react-oidc-context';
import { toast } from 'sonner';

export const AuthToast: React.FC = () => {
  const auth = useAuth();

  React.useEffect(() => {
    if (auth.isAuthenticated && !auth.isLoading) {
      toast.success('Successfully signed in!');
    }

    if (auth.error) {
      toast.error(`Authentication error: ${auth.error.message}`);
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.error]);

  return null;
};
